import React from 'react';
import { Col, Form, FormModal, Input, Row, Select } from 'components';
import { useLegalEditModal } from 'feature/supplierTabs/pricing/legal/edit/useLegalEditModal';
import { useSupplierFormationTypeQuery } from 'api';

const { Item } = Form;

export interface ILegalEditeModal {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit?: Record<string, any>;
}

export const LegalEditeModal = (props: ILegalEditeModal) => {
  const { modalState, onModalStateChange, dataToEdit } = props;
  const { data = [] } = useSupplierFormationTypeQuery();
  const { onFinish, onCancel, form, isLoading } = useLegalEditModal({
    modalState,
    onModalStateChange,
    dataToEdit,
  });
  return (
    <FormModal
      form={form}
      title={'Update Legal Information'}
      width={680}
      okText={'Save'}
      open={modalState}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Item name={'name'} label={'Legal Name'}>
            <Input size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item name={'formationType'} label={'Formation Type'}>
            <Select options={data} size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item name={'taxNumber'} label={'Tax Number'}>
            <Input size={'large'} />
          </Item>
        </Col>
      </Row>
    </FormModal>
  );
};
